import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { toast } from 'components/global/CUK/Toast/Toast'
import ActionModal from 'components/Modal/ActionModal'

import { useDetail } from '../use-bypass'
import { useRemove } from '../use-actions'

const ActionRemove = () => {
  const { t } = useTranslation()
  const {item} = useDetail()
  const navigate = useNavigate()
  const [remove, {loading}] = useRemove()
  const handleClose = () => navigate('..')

  const handleRemove = async () => {
    const { error } = await remove()
    if (error) {
      toast.error(t('bypass.modal.remove.error'))
    } else {
      toast.success(t('bypass.modal.remove.success'))
    }
    navigate('../..')
  }

  return (
    <ActionModal
      cancelLabel={t('ui_elements.cancel')}
      confirmLabel={t('ui_elements.remove')}
      description={t('bypass.modal.remove.description', {mac_address: item?.mac_address})}
      icon={<i className="fa-regular fa-trash" />}
      loading={loading}
      onClose={handleClose}
      onConfirm={handleRemove}
      title={t('bypass.modal.remove.title')}
    />
  )
}

export default ActionRemove